import { render, staticRenderFns } from "./TabTabelaCobranca.vue?vue&type=template&id=5ba1a87c&"
import script from "./TabTabelaCobranca.vue?vue&type=script&lang=ts&"
export * from "./TabTabelaCobranca.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports